<div class="delete-zone-container">
    <jjames-card title="Delete Parking Zone">
        <!-- Loading State -->
        @if (isLoading) {
        <div class="loading-container">
            <p>Loading zone details...</p>
        </div>
        }

        <!-- Confirmation Content -->
        @if (!isLoading) {
        <div class="confirmation-container">
            <!-- Success Alert -->
            @if (successMessage) {
            <jjames-alert type="success" [dismissible]="true" class="alert-spacing">
                {{ successMessage }}
            </jjames-alert>
            }

            <!-- Error Alert -->
            @if (errorMessage) {
            <jjames-alert type="error" [dismissible]="true" class="alert-spacing">
                {{ errorMessage }}
            </jjames-alert>
            }

            <!-- Warning Message -->
            <div class="warning-section">
                <div class="warning-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
                    </svg>
                </div>
                <div class="warning-content">
                    <h3>Are you sure you want to delete this parking zone?</h3>
                    <p>This action cannot be undone. All associated data will be permanently removed.</p>
                </div>
            </div>

            <!-- Zone Information -->
            @if (currentZone) {
            <div class="zone-info">
                <h4>Zone Information</h4>
                <div class="info-grid">
                    <div class="info-item">
                        <label>Name:</label>
                        <span>{{ currentZone.name || 'N/A' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Description:</label>
                        <span>{{ currentZone.description || 'No description' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Capacity:</label>
                        <span>{{ currentZone.capacity || 0 }} spaces</span>
                    </div>
                    <div class="info-item">
                        <label>Governance Type:</label>
                        <span>{{ currentZone.governanceType || 'N/A' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Address:</label>
                        <span>{{ getZoneAddressString() }}</span>
                    </div>
                    @if (currentZone.id) {
                    <div class="info-item">
                        <label>Zone ID:</label>
                        <span class="zone-id">{{ currentZone.id }}</span>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- Action Buttons -->
            <div class="form-actions">
                <jjames-button type="button" variant="secondary" (click)="onCancel()" [disabled]="isDeleting">
                    Cancel
                </jjames-button>

                <jjames-button type="button" variant="primary" class="delete-button" (click)="onConfirmDelete()"
                    [disabled]="isDeleting">
                    {{ isDeleting ? 'Deleting...' : 'Delete Zone' }}
                </jjames-button>
            </div>
        </div>
        }
    </jjames-card>
</div>